export default __webpack_public_path__ + "static/media/copyright-logo.2eb28990.png";